import { FaCheck } from "react-icons/fa";

const CartTopSection = ({ steps, subtitle }) => {
  return (
    <div className="mb-5 bg-white p-4 shadow-sm ring-1 ring-slate-100 sm:p-5">
      <h1 className="text-lg font-semibold text-slate-900 sm:text-3xl">
        Cart Details
      </h1>
      <p className="text-sm text-slate-600 sm:text-base">{subtitle}</p>

      <div className="mt-4 grid grid-cols-3 gap-2 sm:grid-cols-3">
        {steps.map((step) => (
          <div
            key={step.id}
            className={`flex items-center gap-2 rounded-lg border px-2 py-2 text-sm ${
              step.state === "current"
                ? "border-blue-300 bg-blue-50 text-blue-700"
                : step.state === "done"
                  ? "border-emerald-300 bg-emerald-50 text-emerald-700"
                  : "border-slate-200 bg-slate-50 text-slate-500"
            }`}
          >
            <span
              className={`inline-flex h-6 w-6 items-center justify-center rounded-full text-xs font-bold ${
                step.state === "current"
                  ? "bg-blue-600 text-white"
                  : step.state === "done"
                    ? "bg-emerald-600 text-white"
                    : "bg-slate-300 text-slate-700"
              }`}
            >
              {step.state === "done" ? (
                <FaCheck className="text-[10px]" />
              ) : (
                step.id
              )}
            </span>
            <span className="font-semibold sm:text-base text-xs">
              {step.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CartTopSection;
